import React from 'react';
import { registerStockFormat } from '../api';
import FormatCompletionDialog from './quickPriceList/FormatCompletionDialog';
import { isRegistryStockPurchase } from '../utils/stockPurchaseFormat';

export default function StockFormatRegistrationDialog({ stock, product = {}, variety = {}, branchId, canUpdateProduct, canUpdatePrice, onSaved, onClose }) {
  const salesSnapshot = stock.sellingSnapshot || stock.purchaseSnapshot;
  const savedFormat = stock.purchaseFormat;
  const format = savedFormat || {
    metricUnit: salesSnapshot?.metricUnit || stock.metricUnit || '',
    unitWeightKg: salesSnapshot?.weightKg ?? stock.weightKg ?? stock.weight ?? '',
    baseQuantityPerUnit: salesSnapshot?.inventoryBaseUnit === 'kg' ? '' : salesSnapshot?.baseQuantityPerUnit ?? '',
    productFormatName: 'Pack', completion: stock.purchaseFormatCompletion,
  };
  return <FormatCompletionDialog branchId={branchId} registration
    product={{ ...product, category: product.category || product.Category, name: product.name || product.productName || stock.productName || 'Producto' }}
    variety={{ ...variety, name: variety.name || variety.varietyName || stock.varietyName || 'Variedad', inventoryBaseUnit: variety.inventoryBaseUnit || salesSnapshot?.inventoryBaseUnit }}
    format={{ ...format, completion: stock.purchaseFormatCompletion || format.completion }}
    canUpdateProduct={canUpdateProduct} canUpdatePrice={canUpdatePrice} lockIdentity={isRegistryStockPurchase(stock)}
    saveFormat={(payload) => registerStockFormat(branchId, stock.id, payload)}
    onSaved={onSaved} onClose={onClose} />;
}
